import { createFileRoute } from '@tanstack/react-router';
import { CVTemplateSelector, enLabels, frLabels } from '@flemme-template/components';
import { useProfileOnboarding } from '@/context/OnboarrdingContext';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { cv_example } from '@/const/example';
import LanguageSwitcher from '@/components/LanguageSwitcher';

export const Route = createFileRoute('/')({
  component: App,
});

function App() {
  const navigate = useNavigate();
  const { profileResponse, setSelectedTemplate } = useProfileOnboarding();
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage;

  const handleTemplateSelect = (template: any) => {
    setSelectedTemplate(template);
    if (
      profileResponse?.profile?.email &&
      (profileResponse?.profile?.educations?.length ||
        profileResponse?.profile?.experiences?.length)
    ) {
      navigate({ to: '/get-offer-details' });
    } else {
      navigate({ to: '/import-profile' });
    }
  };

  return (
    <main className="bg-gray-100">
      <div className="flex justify-center pt-8">
        <LanguageSwitcher />
      </div>
      <header className="text-center py-8 max-w-[840px] mx-auto">
        <h1 className="h1 mb-2">{t('index.title')}</h1>
        <p className="body-1 text-gray">{t('index.description')}</p>
      </header>
      <div className="p-4">
        <CVTemplateSelector
          labels={language === 'fr' ? frLabels : enLabels}
          profile={cv_example}
          onTemplateSelected={handleTemplateSelect}
        />
      </div>
    </main>
  );
}
